// A failed steps PUT whose refusal the card it names can't show (another
// step's, or the list's): said in the page's own words, as its checks are.

import { toast } from "@pej/kore/components";
import { ApiError } from "@/api/error";
import { toastMutationError } from "@/components/error-toast";
import { describeStepsProblem, serverStepsProblem } from "./step-list";

export function toastStepsError(title: string, error: unknown) {
    const problem = error instanceof ApiError ? serverStepsProblem(error) : undefined;
    if (problem) {
        toast.error(title, { description: describeStepsProblem(problem) });
        return;
    }
    // Field errors outside the steps (none expected) are listed, not lost.
    toastMutationError(title, error, { unmapped: error instanceof ApiError ? error.errors : undefined });
}
